export { default } from './backgroundImage';
